import React from 'react';
import Box from '@mui/material/Box';
import Radio from '@mui/material/Radio';
import { GlobalRadioProps } from '../../types';

// Accessibility: label or aria-label is required for all radio buttons for screen reader support.
export const GlobalRadio: React.FC<GlobalRadioProps> = ({ label, value, ...passThroughProps }) => {
    return (
        <Box sx={{ display: 'flex' }}>
            <Radio
                value={value}
                name={`radio-button-${value}`}
                inputProps={{ 'aria-label': label || value.toString() }}
                {...passThroughProps}
            />
            <p>{label}</p>
        </Box>
    );
}; 